// extracted by mini-css-extract-plugin
module.exports = {"container":"Info_container__z4_GP"};